require("./my.gifts.css")
require("./dialog.common.css")
require("./qb.down.css")
require("./share.getChance.css")
require("./show.prize.css")
require("./user.contact.css")
require("./little.follow.css");

require("./answer.end.css")
require("./answer.num.css")

let dialog = require("@components/dialog")

let QBDown = require("./qb.down.html")
let myGifts = require("./my.gifts.html")
let showPrize = require("./show.prize.html")
let shareGetChance = require("./share.getChance.html")
let notSub = require("./not.sub.html")
let activtyEnd = require("./activty.end.html")
let userContact = require("./user.contact.html")

let answerEnd = require("./answer.end.html")
let answerNum = require("./answer.num.html")
let littleFollow = require("./little.follow.html");

let userInfoObj = JSON.parse(sessionStorage.getItem("userInfo"));
let errorCode = require("./error.code.html");

function mask(type, title, msg, headsrc, width, height) {
  if (type === "QBrowser") {
    console.trace();
    dialog({
      width: 500,
      height: 290,
      className:'activtyEnd',
      body: QBDown({
        title: title,
        msg: msg
      }),
      onclose: function () {},
      onshow: function () {
        if (msg == '请前往电脑参与') {
          $('.pcqb-QBDown-btn').hide()
        }
      }
    }).show()
  } else if (type === "myGifts") {
    dialog({
      width: 820,
      height: 428,
      body: myGifts({}),
      className:'mygifts',
      onclose: function () {

      },
      onshow: function () {
        setTimeout(function () {
          $("#qtips").mouseover(function () {
            $(this).css("overflow", "visible")
          })
          $(".duiRule").mouseout(function () {
            $("#qtips").css("overflow", "hidden")
          })
          $(".duiRuleQr").mouseout(function () {
            $("#qtips").css("overflow", "hidden")
          })
        }, 400)
      }
    }).show()
  } else if (type === "showPrize") {
    dialog({
      width: 550,
      height: 590,
      body: showPrize({}),
    }).show()
  } else if (type === "shareGetChance") {
    dialog({
      width: 550,
      height: 280,
      className:'activtyEnd',
      body: shareGetChance({}),
      onclose: function () {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      },
      onshow: function () {}
    }).show()
  } else if (type === "notSub") {
    dialog({
      width: 550,
      height: 280,
      body: notSub({}),
      onclose: function () {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      },
    }).show()
  } else if (type === "activtyEnd") {
    dialog({
      width: 550,
      height: 280,
      className:'activtyEnd',
      body: activtyEnd({
        title: title,
        msg: msg
      }),
      onclose:function () {
        if(msg=="为选手投票可额外获得1次抽奖机会哦！"){
          console.log("scroll to anchor!!!!!!!!!!");
          $("html,body").animate({
            scrollTop: 830
          }, 200);
        }
      }
    }).show()
  } else if (type === "userCon") {
    dialog({
      width: 550,
      height: 485,
      body: userContact({
        title: title,
        msg: msg
      }),
      onclose: function () {

        var userInfo = {
          "userName": $("#userName").val(),
          "phoneNum": $("#phoneNum").val(),
          "provinceId_m": $("#provinceId_m").val(),
          "cityId_m": $("#cityId_m").val(),
          "areaId_m": $("#areaId_m").val(),
          "detailAddr": $("#detailAddr").val(),
          "zipCode": $("#zipCode").val()
        }
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
      },
      onshow: function () {
        if (!window.userInfoObj) { //非空校验
          return;
        }
        setTimeout(function () {
          $("#userName").val(userInfoObj["userName"])
          $("#phoneNum").val(userInfoObj["phoneNum"])
          $("#provinceId_m").val(userInfoObj["provinceId_m"])
          $("#cityId_m").val(userInfoObj["cityId_m"])
          $("#areaId_m").val(userInfoObj["areaId_m"])
          $("#detailAddr").val(userInfoObj["detailAddr"])
          $("#zipCode").val(userInfoObj["zipCode"])
        }, 500)
      }
    }).show()
  } else if (type === "answerEnd") {
    dialog({
      width: 550,
      height: 280,
      body: answerEnd({
        title: title,
        msg: msg
      }),
    }).show()
  } else if (type === "answerNum") {
    dialog({
      width: 550,
      height: 380,
      body: answerNum({
        headsrc: headsrc,
        title: title,
        msg: msg
      }),
    }).show()
  }
  else if(type === "errorCode"){
    dialog({
      width: 550,
      height: 280,
      body: errorCode({
        title: title,
        msg: msg,
      }),
      onshow: function () {
      },
      onclose:function () {
      }
    }).show()

  }
  else if (type === "littleFollow") {
    dialog({
      width: 550,
      height: 280,
      body: littleFollow({
        title: title,
        msg: msg,
      }),
      onshow: function () {
        if (msg === '对不起，你已经抽过奖了') {
          lottery.oneClick = true
        } else if (msg === '关注满3个主播才可以抽奖喔') {
          lottery.onlyClick = true
        } else if (msg === '参与活动才有抽奖机会哟~') {
          lottery.onlyClick = true
        }
      },
      onclose:function () {
        if(msg == '你还有抽奖机会待领取'){
          $("html,body").animate({scrollTop:830},200);
        }
      }
    }).show()
  }
}

module.exports = mask



// WEBPACK FOOTER //
// ./modules/mask/index.js